import * as React from "react";

const columns = (t) => [

    {
        field: "name",
        label: t ? t("common.name") : "Nazwa",
        sort: "desc",
        width: 100,
    },
    {
        field: "value",
        label: t ? t("common.value") : "Wartość",
        sort: "desc",
        width: 100
    },
    {
        field: "comment",
        label: t ? t("common.comment") : "Komentarz",
        sort: "desc",
        width: 150
    }
];

export default columns;
